import {epics as contextMenuEpics} from './context-menu/redux';
import {epics as manageAccessEpics} from './manage-access/redux';


export const epics = [
  ...contextMenuEpics,
  ...manageAccessEpics,
];



// WEBPACK FOOTER //
// ./src/js/core-components/epics.js